import * as tslib_1 from "tslib";
import { BUSINESS_CONST } from '../../constants/business.constants';
import { LogDeviceModel } from '../../models/log-device.model';
import { NumberPipe } from '../../pipe/number.pipe';
import { AbreCuentasService } from '../abre-cuentas/abre-cuentas.service';
import { BioCatchService } from '../external/biocatch/biocatch.service';
import { FirmlyApprovedService } from '../firmly-approved/firmly-approved.service';
import { NavigationService } from '../navigation/navigation-onboarding.service';
import { RequestService } from '../request/request-onboarding.service';
import { ProductsService } from '../products/products.service';
import { BitacoraService } from '../bitacora/bitacora.service';
import { OpEnum } from '../../enums/op.enum';
import { ParametersService } from '../parameters/parameters.service';
import { BehaviorSubject } from 'rxjs';
import { CaptureService } from '../capture/capture.service';
import * as i0 from "@angular/core";
import * as i1 from "../request/request-onboarding.service";
import * as i2 from "../external/biocatch/biocatch.service";
import * as i3 from "../abre-cuentas/abre-cuentas.service";
import * as i4 from "../../pipe/number.pipe";
import * as i5 from "../navigation/navigation-onboarding.service";
import * as i6 from "../firmly-approved/firmly-approved.service";
import * as i7 from "../products/products.service";
import * as i8 from "../bitacora/bitacora.service";
import * as i9 from "../parameters/parameters.service";
import * as i10 from "../capture/capture.service";
var ConfigurationService = /** @class */ (function () {
    function ConfigurationService(requestService, bioCatchService, abreCuentasService, numberpipe, navigationService, firmlyApprovedService, productsService, bitacoraService, parametersService, captureService) {
        this.requestService = requestService;
        this.bioCatchService = bioCatchService;
        this.abreCuentasService = abreCuentasService;
        this.numberpipe = numberpipe;
        this.navigationService = navigationService;
        this.firmlyApprovedService = firmlyApprovedService;
        this.productsService = productsService;
        this.bitacoraService = bitacoraService;
        this.parametersService = parametersService;
        this.captureService = captureService;
        this.devicePrint = new LogDeviceModel();
        this.valueAmountKeys = {
            'Mastercard': 'value_master',
            'Visa': 'value_visa',
            'Visa LifeMiles': 'value_visalf',
        };
        this.productIsReady$ = new BehaviorSubject(false);
    }
    /**
     * Validación de aceptación de términos y condiciones, registro en la bítacora
     *
     * *Terms and conditions acceptance validation*
     */
    ConfigurationService.prototype.termsAndConditions = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var ipBiocatch;
            return tslib_1.__generator(this, function (_a) {
                try {
                    ipBiocatch = this.bioCatchService.getCurrentScoreIp();
                    this.devicePrint.device = this.abreCuentasService.getDeviceInfo();
                    if (this.devicePrint !== undefined && this.devicePrint !== null) {
                        this.devicePrint.device.ip = ipBiocatch;
                        this.devicePrint.terms_type = 'term_condicion_acept';
                        this.devicePrint.device.event_name = 'term_condicion_acept';
                        this.abreCuentasService.setdeviceInfo(this.devicePrint);
                        return [2 /*return*/, this.requestService.saveDataInBitacora(this.devicePrint)];
                    }
                }
                catch (error) {
                    console.log(error);
                }
                return [2 /*return*/];
            });
        });
    };
    /**
     * Función asíncrona para enviar la información de configuración
     *
     * *Async Function that sends config*
     *
     * @type {function}
     * @returns {Promise}
     */
    ConfigurationService.prototype.offersConfig = function (body) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.requestService
                            .offersConfig(body)
                            .then(function (res) { return resolve(res); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    /**
     * Función guardar información financiera
     *
     * *Function that saves financial info*
     *
     * @param {any} body
     */
    ConfigurationService.prototype.getCardCategoryByBrand = function (body) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.requestService
                            .getCardCategoryByBrand(body)
                            .then(function (res) { return resolve(res); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    /**
     * Función asíncrona para enviar la información de beneficios
     *
     * *Async Function that get benefits*
     *
     * @type {function}
     * @returns {Promise}
     */
    ConfigurationService.prototype.offersGetBenefits = function (agreementCode) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.requestService
                            .offersGetBenefits(agreementCode)
                            .then(function (res) { return resolve(res); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    /**
     * Función asíncrona para enviar la información de beneficios
     *
     * *Async Function that get benefits*
     *
     * @type {function}
     * @returns {Promise}
     */
    ConfigurationService.prototype.benefitsFilter = function (benefitsList) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var benefitListFiltered, listBenefitsCombinationFlag, final_text_withdrawals, quantity_combitation_flag_1;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                benefitListFiltered = [];
                listBenefitsCombinationFlag = [];
                benefitsList.forEach(function (benefit) {
                    switch (benefit.benefit_id) {
                        case '638':
                            if (benefit.quantity === '999') {
                                benefitListFiltered.push("Retiros ilimitados en " + benefit.type);
                            }
                            else if (benefit.quantity !== '0') {
                                if (benefit.combination_flag) {
                                    listBenefitsCombinationFlag.push(benefit);
                                }
                                else {
                                    benefitListFiltered.push(benefit.quantity + " Retiros en " + benefit.type);
                                }
                            }
                            break;
                        case '685':
                            var valor = _this.numberpipe.transform(benefit.amount_benefit.amount
                                .toString()
                                .slice(0, benefit.amount_benefit.amount.toString().length -
                                benefit.amount_benefit.decimals), 'document', '.');
                            console.log('VALOR', valor);
                            var agreementSelected = _this.abreCuentasService.getAgreementSelected();
                            var quantity = parseInt(benefit.quantity, 10);
                            if (agreementSelected.agreement_code === '1606') {
                                benefitListFiltered.push('Sin cuota de manejo, mientras recibas tu nómina');
                            }
                            else if (valor && quantity > 1) {
                                benefitListFiltered.push("Cuota de manejo $ " + valor + " mensuales con exoneraci\u00F3n de " + quantity + " meses");
                            }
                            else {
                                benefitListFiltered.push('Sin cuota de manejo');
                            }
                            break;
                        default:
                            break;
                    }
                });
                if (listBenefitsCombinationFlag.length > 0) {
                    final_text_withdrawals = '';
                    quantity_combitation_flag_1 = 0;
                    listBenefitsCombinationFlag.forEach(function (benefits_combination_flag) {
                        if (+benefits_combination_flag.quantity > quantity_combitation_flag_1) {
                            quantity_combitation_flag_1 = +benefits_combination_flag.quantity;
                        }
                    });
                    final_text_withdrawals += quantity_combitation_flag_1 + " Retiros en otras redes ";
                    benefitListFiltered.push(final_text_withdrawals);
                }
                benefitListFiltered.push('Transferencias digitales ilimitadas desde y hacia otros bancos.');
                this.abreCuentasService.setBenefitsList(benefitListFiltered);
                return [2 /*return*/];
            });
        });
    };
    ConfigurationService.prototype.sendCardInformation = function () {
        var _this = this;
        this.firmlyApproved = this.firmlyApprovedService.isFirmlyApproved();
        var selectedProduct = this.abreCuentasService.getPayDayProductSelected().selectedProduct;
        if (Array.isArray(selectedProduct)) {
            this.cardInformationMultiproduct(selectedProduct);
            return;
        }
        var detailTC = this.firmlyApprovedService.getDetailProductsMulti(BUSINESS_CONST.PRODUCT_TYPE_TC);
        var resultPco = this.firmlyApproved
            ? false
            : this.abreCuentasService.getPcoModel();
        var detailTC_FirmlyApproved;
        var productFirmlyApproved;
        if (this.firmlyApproved) {
            productFirmlyApproved =
                this.firmlyApprovedService.getProduct_FirmlyApproved(BUSINESS_CONST.PRODUCT_CODE_TCR);
            detailTC_FirmlyApproved = detailTC[0];
            console.log('firmlyApproved: ', this.firmlyApproved, '\n productFirmlyApproved: ', productFirmlyApproved, 'DetailTC: ', detailTC);
        }
        var body = {
            data: {
                brand: this.firmlyApproved
                    ? detailTC_FirmlyApproved.brand.replace('LifeMiles', 'LIFE MILES').toUpperCase()
                    : selectedProduct
                        ? selectedProduct.label
                            .replace('LifeMiles', 'LIFE MILES')
                            .toUpperCase()
                        : '',
                campaign: this.firmlyApproved
                    ? this.firmlyApprovedService.getOfferType_Channel()
                    : 'Itau Extremo',
                invoice_cycle: '1',
                creditcard_amount: {
                    currency: resultPco
                        ? this.getCurrency(resultPco)
                        : this.firmlyApproved
                            ? detailTC_FirmlyApproved.limit_amount.currency
                            : 0,
                    amount: resultPco
                        ? this.getAmount(resultPco)
                        : this.firmlyApproved
                            ? detailTC_FirmlyApproved.limit_amount.amount
                            : 0,
                    decimals: 0,
                },
                all_products: true,
                simulation_type: 'detallada',
            },
        };
        console.log('Envio a CardCategory >>> body: ', body);
        this.getCardCategoryByBrand(body).then(function (result) {
            try {
                console.log('Obteniendo el CardTypes: ', result);
                // if (result.status === 200) {
                //   this.abreCuentasService.setCardTypeModel(result.data[0]);
                if (+result.status === 200) {
                    result.body.data[0].brand = body.data.brand;
                    _this.abreCuentasService.setCardTypeModel(result.body.data[0]);
                    if (_this.abreCuentasService.getUserJemelii()) {
                        _this.navigationService.nextStep('203');
                    }
                    else if (!_this.abreCuentasService.viewOptionMultiProduct) {
                        _this.navigationService.nextStep('200');
                    }
                    else {
                        _this.navigationService.nextStep(_this.navigationService.nextMulti(_this.abreCuentasService.getProductsSelects()));
                    }
                }
                else {
                    if (result.status === 500) {
                        throw 500;
                    }
                    _this.abreCuentasService.caseInfoError('512');
                    _this.navigationService.nextStep('121');
                }
            }
            catch (error) {
                _this.navigationService.navigateToGeneralInformation('500');
            }
        });
    };
    ConfigurationService.prototype.cardInformationMultiproduct = function (selectedProduct) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var cardTypes, productsMulti, resultPcoTc, configValues, _loop_1, this_1, selectedProduct_1, selectedProduct_1_1, product, e_1_1;
            var e_1, _a;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        cardTypes = {};
                        productsMulti = [];
                        console.log('cardInformationMultiproduct: ', selectedProduct);
                        resultPcoTc = this.firmlyApproved
                            ? this.firmlyApprovedService.getDetailProductsMulti(BUSINESS_CONST.PRODUCT_TYPE_TC)
                            : this.abreCuentasService.getproductSelected().product_type ===
                                BUSINESS_CONST.MULTI
                                ? this.abreCuentasService
                                    .getPcoModel()
                                    .granted_product_multi.find(function (prod) { return prod.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC; })
                                : this.abreCuentasService.getPcoModel().granted_product;
                        if (resultPcoTc === undefined) {
                            return [2 /*return*/];
                        }
                        configValues = this.abreCuentasService.getConfigurationValues();
                        console.log('abrecuentas Service: ', this.abreCuentasService, '\n resultPCO: ', resultPcoTc);
                        _loop_1 = function (product) {
                            var brand_select, body;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        brand_select = this_1.firmlyApprovedService.selectedBrand(product.elementId);
                                        body = {
                                            data: {
                                                brand: this_1.firmlyApproved
                                                    ? brand_select.replace('LifeMiles', 'LIFE MILES').toUpperCase()
                                                    : product.label.replace('LifeMiles', 'LIFE MILES').toUpperCase(),
                                                campaign: this_1.firmlyApproved ? this_1.firmlyApprovedService.getOfferType_Channel() : 'Itau Extremo',
                                                invoice_cycle: '1',
                                                creditcard_amount: this_1.firmlyApproved
                                                    ? resultPcoTc.find(function (card) { return card.brand === brand_select; }).limit_amount
                                                    : {
                                                        currency: resultPcoTc.limit_amount.currency,
                                                        amount: Number(configValues[this_1.valueAmountKeys[product.label]]),
                                                        decimals: 0,
                                                    },
                                                all_products: true,
                                                simulation_type: 'detallada',
                                            },
                                        };
                                        console.log('body', body);
                                        productsMulti.push({
                                            brand: product.label,
                                            product_type: BUSINESS_CONST.PRODUCT_TYPE_TC,
                                            limit_amount: this_1.firmlyApproved
                                                ? resultPcoTc.find(function (card) { return card.brand === brand_select; }).limit_amount
                                                : {
                                                    currency: resultPcoTc.limit_amount.currency,
                                                    amount: Number(configValues[this_1.valueAmountKeys[product.label]]),
                                                    decimals: 0,
                                                },
                                        });
                                        console.log('Envio a CardCategory >>> body: ', body);
                                        return [4 /*yield*/, this_1.getCardCategoryByBrand(body).then(function (result) {
                                                try {
                                                    console.log('Result 337: ', result);
                                                    if (+result.status === 200) {
                                                        cardTypes[product.label] = result.body.data[0];
                                                        cardTypes[product.label].brand = product.label;
                                                    }
                                                    else {
                                                        if (result.status === 500) {
                                                            throw 500;
                                                        }
                                                        _this.abreCuentasService.caseInfoError('512');
                                                        _this.navigationService.nextStep('121');
                                                    }
                                                }
                                                catch (error) {
                                                    _this.navigationService.navigateToGeneralInformation('500');
                                                }
                                            })];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        };
                        this_1 = this;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 6, 7, 8]);
                        selectedProduct_1 = tslib_1.__values(selectedProduct), selectedProduct_1_1 = selectedProduct_1.next();
                        _b.label = 2;
                    case 2:
                        if (!!selectedProduct_1_1.done) return [3 /*break*/, 5];
                        product = selectedProduct_1_1.value;
                        return [5 /*yield**/, _loop_1(product)];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4:
                        selectedProduct_1_1 = selectedProduct_1.next();
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        e_1_1 = _b.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 8];
                    case 7:
                        try {
                            if (selectedProduct_1_1 && !selectedProduct_1_1.done && (_a = selectedProduct_1.return)) _a.call(selectedProduct_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7 /*endfinally*/];
                    case 8:
                        console.log('CardTypes: ', cardTypes);
                        if (this.firmlyApproved) {
                            this.abreCuentasService.getPcoModel().granted_product_multi = this.firmlyApprovedService.getDetailProductsMulti();
                        }
                        console.log('AbreCuentasService: ', this.abreCuentasService);
                        console.log('GrantedProductMulti: ', this.abreCuentasService.getPcoModel().granted_product_multi);
                        this.abreCuentasService.getPcoModel().granted_product_multi =
                            this.abreCuentasService
                                .getPcoModel()
                                .granted_product_multi.filter(function (prod) {
                                return prod.product_type !== BUSINESS_CONST.PRODUCT_TYPE_TC &&
                                    (prod.brand === undefined || prod.brand === '');
                            });
                        this.abreCuentasService.getPcoModel().granted_product_multi =
                            this.abreCuentasService
                                .getPcoModel()
                                .granted_product_multi.concat(productsMulti);
                        this.abreCuentasService.setCardTypesModel(cardTypes);
                        console.log('cardTypes: ', this.abreCuentasService.getCardTypesModel());
                        if (!this.abreCuentasService.viewOptionMultiProduct) {
                            this.navigationService.nextStep('200');
                        }
                        else {
                            this.navigationService.nextStep(this.navigationService.nextMulti(this.abreCuentasService.getProductsSelects()));
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ConfigurationService.prototype.getCurrency = function (resultPco) {
        if (resultPco.granted_product_multi.length > 0) {
            return resultPco.granted_product_multi.filter(function (fil) { return fil.product_type === 'creditCard'; })[0].limit_amount.currency;
        }
        else {
            return resultPco.granted_product.limit_amount.currency;
        }
    };
    ConfigurationService.prototype.getAmount = function (resultPco) {
        console.log('resultPco_', resultPco);
        if (resultPco.granted_product_multi.length > 0) {
            var amount = resultPco.granted_product_multi.filter(function (fil) { return fil.product_type === 'creditCard'; })[0].limit_amount.amount;
            return amount.toString().replace('$ ', '').split(/\./).join('');
        }
        else {
            var amount = resultPco.granted_product.limit_amount.amount;
            return amount.toString().replace('$ ', '').split(/\./).join('');
        }
    };
    /**
     * Función guardar información de financiera
     *
     * *Function that saves financial info*
     *
     */
    ConfigurationService.prototype.getRatesByAllies = function (codeallies) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.requestService
                            .validateInfo(codeallies)
                            .then(function (res) { return resolve(res); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    /**
     * Función encargada de leer el producto que el usuario
     * seleccionó en la opción de Productos, dejando de
     * esta forma de una vez el producto seleccionado en Onboarding
     * para iniciar el respectivo Flujo.
     * @param {string} productPreSelected - Producto seleccionado
     */
    ConfigurationService.prototype.selectProduct = function (productPreSelected) {
        console.warn('Producto preseleccionado: ', productPreSelected);
        var product = this.parametersService.getSetting(OpEnum.ABRE_CUENTAS_PRODUCTS_CE);
        console.log('Productos pre cargados: ', product);
        var productSelected = product.find(function (prod) { return prod.product_code === productPreSelected; });
        console.warn('PRODUCTO SELECCIONADO: ', productSelected);
        if (productSelected) {
            this.validateBiocatch(productSelected);
        }
        else {
            this.setProductIsReady(true);
        }
    };
    ConfigurationService.prototype.validateBiocatch = function (product) {
        var _this = this;
        this.abreCuentasService.setproductSelected(product);
        this.bioCatchService
            .checkCountry(false)
            .then(function (response) {
            if (response.data.response || !_this.bioCatchService.getGeoServiceComplete()) {
                _this.selectProductType(product);
            }
            else {
                _this.navigationService.navigateToGeneralInformation('dsbException');
            }
        }, function (error) {
            console.error('BiocatchError..');
            console.error(error);
            _this.navigationService.navigateToGeneralInformation('500');
            if (!_this.abreCuentasService.getPostlogin()) {
                _this.navigationService.pageLoadTag(false, ['pv415', '', '', '']);
            }
        }).catch(function () { return _this.navigationService.navigateToGeneralInformation('500'); });
    };
    /**
     * Función que permite identificar el tipo del producto seleccionado por el usuario,
     * permite identificar los activos de los pasivos.
     * @param {IProductsModel} product - Producto seleccionado
     */
    ConfigurationService.prototype.selectProductType = function (product) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                this.productsService.assignProductType(product).then(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    var _this = this;
                    return tslib_1.__generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                console.log('Producto seleccionado: ', product);
                                if (!(product.name === BUSINESS_CONST.PRODUCT_REQUEST_CONSULT && this.abreCuentasService.getPostlogin())) return [3 /*break*/, 2];
                                return [4 /*yield*/, this.validateDataConsultationRquest()];
                            case 1:
                                _a.sent();
                                return [3 /*break*/, 3];
                            case 2:
                                if (product.product_type === BUSINESS_CONST.PRODUCT_TYPE_PAYROLL) {
                                    this.productsService.getAgreementsOffers()
                                        .then(function () {
                                        console.log('Cargue exitoso de convenios.');
                                        _this.setProductIsReady(true);
                                    })
                                        .catch(function () { return _this.navigationService.navigateToGeneralInformation('500'); });
                                }
                                else {
                                    this.setProductIsReady(true);
                                }
                                _a.label = 3;
                            case 3:
                                this.saveDataInBitacora(product);
                                return [2 /*return*/];
                        }
                    });
                }); }).catch(function (error) {
                    console.error(error);
                    _this.setProductIsReady(false);
                    _this.navigationService.navigateToGeneralInformation('500');
                });
                return [2 /*return*/];
            });
        });
    };
    ConfigurationService.prototype.validateDataConsultationRquest = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var requestData;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.captureService.getRequestsByClient(this.abreCuentasService.getDocumentInfo().document_number + "_" + this.abreCuentasService
                            .getDocumentInfo().document_type.replace('0', ''))];
                    case 1:
                        requestData = _a.sent();
                        console.log('getRequestsByClient: ', requestData);
                        if (requestData.code !== '200') {
                            this.navigationService.setCodeError('131');
                            // this.navigationService.navigateToGeneralInformation('131');
                        }
                        else if (requestData.code === '200' && requestData.data.length === 0) {
                            this.navigationService.setCodeError('141');
                            // this.navigationService.navigateToGeneralInformation('141');
                        }
                        this.abreCuentasService.setCustomerRequests(requestData.data);
                        this.setProductIsReady(true);
                        return [2 /*return*/];
                }
            });
        });
    };
    ConfigurationService.prototype.saveDataInBitacora = function (product) {
        var biocatchInfo = this.bioCatchService.getBiocatchInfo();
        if (this.abreCuentasService.getIsPortal()) {
            this.bitacoraService.saveDataInBitacora('Chanel_131_Portal');
        }
        this.bitacoraService.saveDataInBitacora(product.product_type);
        if (!!biocatchInfo.ipGeoCity && !!biocatchInfo.ipGeoCountry) {
            var bitacoraEvent = "geo_biocatch_" + biocatchInfo.ipGeoCity + "_" + biocatchInfo.ipGeoCountry;
            this.bitacoraService.saveDataInBitacora(bitacoraEvent);
        }
    };
    ConfigurationService.prototype.setProductIsReady = function (isReady) {
        this.productIsReady$.next(isReady);
    };
    ConfigurationService.prototype.getProductIsReady = function () {
        return this.productIsReady$.asObservable();
    };
    ConfigurationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ConfigurationService_Factory() { return new ConfigurationService(i0.ɵɵinject(i1.RequestService), i0.ɵɵinject(i2.BioCatchService), i0.ɵɵinject(i3.AbreCuentasService), i0.ɵɵinject(i4.NumberPipe), i0.ɵɵinject(i5.NavigationService), i0.ɵɵinject(i6.FirmlyApprovedService), i0.ɵɵinject(i7.ProductsService), i0.ɵɵinject(i8.BitacoraService), i0.ɵɵinject(i9.ParametersService), i0.ɵɵinject(i10.CaptureService)); }, token: ConfigurationService, providedIn: "root" });
    return ConfigurationService;
}());
export { ConfigurationService };
